export const animatedThumbnailsSelector = (state) => state.animatedThumbnails;
